/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconReportMedical = createReactComponent("report-medical", "IconReportMedical", [
  [
    "path",
    {
      d: "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z",
      key: "svg-1"
    }
  ],
  ["path", { d: "M10 14l4 0", key: "svg-2" }],
  ["path", { d: "M12 12l0 4", key: "svg-3" }]
]);

export { IconReportMedical as default };
//# sourceMappingURL=IconReportMedical.js.map
